<div class="page-wrapper h-100">
  <mmoga-header></mmoga-header>
  <div class="p-3">
      <ng-container *ngIf="isLoggedIn">
        <router-outlet></router-outlet>
      </ng-container>
  </div>
  <mmoga-footer></mmoga-footer>
</div>
